import React from "react";
import { CommandBarButton } from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";
import DefaultContextualMenu from "../../../../Table/DefaultContextualMenu";
import FeatureSummary from "../../../../Util/FeatureSummary";

const ReportUsersTable = ({
    reportUsers,
    setSelectedReportUser,
    loading,
    editOnClick,
    createOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            key: "contextMenu",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <DefaultContextualMenu
                    editOnClick={() => editOnClick(item.staffID)}
                    deleteOnClick={() => deleteOnClick(item.staffID, item.emailAddress)}
                />
            ),
        },
        {
            name: "Staff ID",
            key: "staffID",
            fieldName: "staffID",
            minWidth: 100,
            maxWidth: 120,
            isResizable: true,
        },
        {
            name: "First Name",
            key: "firstName",
            fieldName: "firstName",
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: "Last Name",
            key: "lastName",
            fieldName: "lastName",
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
        },
        {
            name: "Email Address",
            key: "emailAddress",
            fieldName: "emailAddress",
            minWidth: 200,
            maxWidth: 260,
            isResizable: true,
        },
        {
            name: "Access Level",
            key: "accessLevel",
            fieldName: "accessLevel",
            minWidth: 120,
            maxWidth: 150,
            isResizable: true,
        },
        {
            name: "Access Name",
            key: "accessName",
            fieldName: "accessName",
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
        },
    ];

    const items = (reportUsers ?? []).map((user) => ({ ...user, key: user.staffID }));

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedReportUser(selectedItem && selectedItem.reportUserId);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={"firstName"}
                hideSelectionDetails
                style={{
                    position: "relative",
                    height: "80vh",
                    width: "80vw",
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: "Add" }}
                        text="Add Report User"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Report Users"
                summary="This table displays all report users, including staff ID, name, email, and access level. You can add, edit, or delete report users. The Report Users feature allows admins to manage user access and permissions for reporting tools within the platform."
            />
        </>
    );
};

export default ReportUsersTable;
